import React from 'react';
import * as icons from 'theme/icons';

export function getGroupIcon(icon?: string|React.ReactNode){
  const IconEl = typeof icon === 'string' ? (icons as any)[icon] : icon;
  
  return IconEl ? <IconEl className="input-group-icon" strokeWidth={2} /> : null;
}